import React from 'react';
import { Dropdown } from '../common/Dropdown';
import { DROPDOWN_POSITIONS } from '../../../constants';
import { getFlagCodeFromLanguage } from '../../../main';
import * as PropTypes from 'prop-types';
const LanguagesDropdown = (props) => {
  return (
    <Dropdown
      position={DROPDOWN_POSITIONS.CENTER}
      isOpen={props.isOpen}
    >
      <div className={'dropdown__content wpml-language-switcher'}>
        <div className={'dropdown__row'}>
          {freedomeConfig.languages &&
            freedomeConfig.languages.map((language, index) => {
              const flag = `circle-flags:lang-${language.code}`;
              return (
                <div key={index} className="dropdown__column">
                  <a href={language.url}>
                    <div>
                      <span className="iconify" data-icon={flag}></span>
                    </div>
                    <div>{language.fullname}</div>
                  </a>
                </div>
              );
            })}
        </div>
      </div>
    </Dropdown>
  );
};

LanguagesDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

LanguagesDropdown.defaultProps = {
  isOpen: false,
};

export default LanguagesDropdown;
